import { UseQueryOptions } from '@tanstack/react-query';
import { useVendorsQuery, VendorsQuery } from '../api/gql';

type Props = {
  queryOptions?: UseQueryOptions<VendorsQuery>;
};

export const useVendorLookup = (props?: Props) => {
  const { data, status, isLoading } = useVendorsQuery(undefined, {
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    ...props?.queryOptions,
  });

  const lookupVendorByVatId = (vatId: string) => data?.vendors.find((vendor) => vendor.vatId === vatId);

  return {
    data,
    isLoading,
    isReady: status === 'success',
    lookupVendorByVatId,
  };
};
